/*
 * @Description:
 * @Author: lyy
 * @Date: 2022-08-05 10:14:34
 * @LastEditors: your Name
 * @LastEditTime: 2022-08-05 10:28:21
 */
import { Message } from 'element-ui';
let timer;
const showMessage = Symbol('showMessage');
/**
 *  重写ElementUI的Message,达到重置的效果
 */
export class DonMessage {
  success (options, single = true) {
    this[showMessage]('success', options, single);
  }
  warning (options, single = true) {
    this[showMessage]('warning', options, single);
  }
  info (options, single = true) {
    this[showMessage]('info', options, single);
  }
  error (options, single = true) {
    this[showMessage]('error', options, single);
  }
  [showMessage] (type, options, single) {
    if (single) {
      // 判断是否已存在Message
     // if (document.querySelector('.el-message')) document.querySelector('.el-message').remove();

      if (document.getElementsByClassName('el-message').length === 0) {
       // if (document.querySelector('.el-message')) document.querySelector('.el-message').remove();
        Message[type](options);
        if (timer) clearTimeout(timer);
         timer = setTimeout(() => {
            clearTimeout(timer);
            if (document.querySelector('.el-message')) document.querySelector('.el-message').remove();
        }, 6000);
      } else {
      }
    //   setTimeout(() => {
    //     alert();
    //     Message.closeAll();
    //     if (document.querySelector('el-message')) document.querySelector('el-message').remove();
    //   }, 3600);
    } else {
      Message[type](options);
    }
  }
}
